import { PanelLeft, PanelRightClose, Globe } from "lucide-react";
import Logo from "@ui/Logo";
import { Link } from "react-router-dom";

import LanguageSwitcher from "./LanguageSwitcher";

const Header = ({
    toggleSidebar,
    sidebarOpen,
    home = "/chat",
    children,
    leftHeaderChildren,
    smallerHeader,
    noMargin,
}) => {
    return (
        <header
            className={`bg-white border-b border-gray-200 transition-all duration-300 ${
                noMargin ? "" : sidebarOpen ? "lg:ml-64" : "lg:ml-[68px]"
            }`}
        >
            <div className="px-3 h-14 flex items-center">
                <div className="flex items-center justify-between w-full">
                    <div className="flex items-center justify-start rtl:justify-end flex-1">
                        <button
                            onClick={toggleSidebar}
                            type="button"
                            className="grid place-content-center w-8 h-8 text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
                        >
                            <span className="sr-only">Toggle sidebar</span>
                            {sidebarOpen ? (
                                <PanelRightClose size={20} />
                            ) : (
                                <PanelLeft size={20} />
                            )}
                        </button>

                        {/* Show leftHeaderChildren if provided, otherwise show default logo */}
                        {leftHeaderChildren ? (
                            <div className="ms-2 w-full">
                                {leftHeaderChildren}
                            </div>
                        ) : (
                            <Link to={home} className="flex ms-2 md:me-24">
                                <Logo className="h-8 me-3" />
                            </Link>
                        )}
                    </div>
                    <div className="flex items-center gap-2">{children}</div>
                </div>
            </div>
        </header>
    );
};

export default Header;
